import { useTutorialStore } from '@/store/tutorialStore'
import { ChevronRight } from 'lucide-react'
import { AngledButton } from './broadcast'

export function TutorialOverlay() {
  const { isActive, currentStep, steps, nextStep, skipTutorial } = useTutorialStore()

  if (!isActive) return null

  const step = steps[currentStep]
  if (!step) return null

  const isLastStep = currentStep === steps.length - 1

  const positionClasses = {
    center: 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    top: 'left-1/2 top-20 -translate-x-1/2',
    bottom: 'left-1/2 bottom-24 -translate-x-1/2',
    left: 'left-4 top-1/2 -translate-y-1/2',
    right: 'right-4 top-1/2 -translate-y-1/2',
  }
  
  return (
    <>
      {/* Dark overlay */}
      <div className="fixed inset-0 z-40" style={{ background: 'rgba(8, 13, 22, 0.55)' }} />

      {/* Tutorial card */}
      <div
        className={`fixed z-50 ${positionClasses[step.position || 'center']}`}
        style={{
          // Fill the viewport width on mobile (capped on desktop) so the card
          // doesn't shrink to its content — matches ConfirmDialog's sizing.
          width: 'min(28rem, 92vw)',
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg), inset 0 3px 0 0 var(--gold)',
          overflow: 'hidden',
        }}
      >
        {/* Progress bar */}
        <div style={{ height: '3px', background: 'var(--fill-soft)' }}>
          <div
            style={{
              height: '100%',
              background: 'var(--gradient-gold)',
              width: `${((currentStep + 1) / steps.length) * 100}%`,
              transition: 'width 0.3s ease',
            }}
          />
        </div>

        <div className="p-5">
          {/* Step indicator */}
          <div
            style={{
              fontFamily: 'var(--font-titles)',
              fontSize: '0.6875rem',
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'var(--gold)',
              marginBottom: '0.5rem',
            }}
          >
            Paso {currentStep + 1} de {steps.length}
          </div>

          {/* Title */}
          <h3
            style={{
              fontFamily: 'var(--font-titles)',
              fontSize: '1.25rem',
              fontWeight: 800,
              color: 'var(--text-primary)',
              marginBottom: '0.5rem',
            }}
          >
            {step.title}
          </h3>

          {/* Message */}
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem', lineHeight: 1.6 }}>
            {step.message}
          </p>

          {/* Buttons */}
          <div className="flex justify-between items-center">
            <button
              onClick={skipTutorial}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: 'var(--text-muted)', fontSize: '0.85rem',
              }}
            >
              Saltar tutorial
            </button>

            <AngledButton tone="gold" onClick={nextStep}>
              {isLastStep ? '¡Empezar!' : 'Siguiente'}
              {!isLastStep && <ChevronRight size={15} />}
            </AngledButton>
          </div>
        </div>
      </div>
    </>
  )
}
